import { ModalName } from "sharedTypes"
import { BadgeTemplate } from "sharedTypes/badge"
import { mobileAppURL } from "utilities/routes"
import { QuickAction } from "./cards/QuickActionsCard"

type Params = {
  canViewGuests: boolean
  isDoorStaff: boolean
  canViewEmails: boolean
  texting: boolean
  canViewSettings: boolean
  checkInLocationsEnabled: boolean
  badgeBuilderEnabled: boolean
  canViewBadges: boolean
  showModal: (name: ModalName, params?: object) => void
  editBadge: (badgeId: string) => void
}

const quickActionGroups = ({
  canViewGuests, isDoorStaff, canViewEmails, texting, canViewSettings,
  checkInLocationsEnabled, badgeBuilderEnabled, canViewBadges, showModal, editBadge,
}: Params): { title: string, actions: QuickAction[] }[] => {
  const open = (name: ModalName) => () => showModal(name)

  return [
    {
      title: "Guests",
      actions: canViewGuests && !isDoorStaff ? [
        { label: "Add a guest", icon: "plus", onClick: open(ModalName.NewGuest) },
        { label: "New guest list", icon: "guest-group", onClick: open(ModalName.GuestListForm) },
        { label: "Import guests", icon: "import", onClick: open(ModalName.ImportGuests) },
      ] : [],
    },
    {
      title: "Messaging",
      actions: [
        ...canViewEmails
          ? [{ label: "New email", icon: "emails", onClick: open(ModalName.NewEmail) }]
          : [],
        ...texting
          ? [{ label: "New text message", icon: "texts", textMenu: true }]
          : [],
      ],
    },
    {
      title: "On-site",
      actions: [
        ...canViewSettings && checkInLocationsEnabled
          ? [{
            label: "New check-in session",
            icon: "session",
            onClick: open(ModalName.EventActivityForm),
          }]
          : [],
        ...badgeBuilderEnabled && canViewBadges
          ? [{
            label: "New badge",
            icon: "badges",
            onClick: () => showModal(ModalName.BadgeTemplateBrowser, {
              onTemplateCreated: ({ id }: BadgeTemplate) => editBadge(id),
            }),
          }]
          : [],
        { label: "Download mobile app", icon: "link-external", href: mobileAppURL() },
      ],
    },
  ]
}

export default quickActionGroups
